import React from 'react';
import FadoelTypePopup from '../../../../../containers/FadoelTypeView/FadoelTypePopup';
import { InfoTitle, InfoCol, InfoDiv } from './styles/InfoStyles';


const RenderFadoelsType = ({
  fadoelsType,
}) => {
  if (fadoelsType) {
    return (
      <InfoCol>
        <InfoDiv>
          <InfoTitle>Type:</InfoTitle>
          <FadoelTypePopup type={fadoelsType} greyLight>
            {fadoelsType}
          </FadoelTypePopup>
        </InfoDiv>
      </InfoCol>
    );
  }
  return (null);
};

// Export
export default RenderFadoelsType;
